import React, { useState, useEffect } from "react";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import CustomInput from "components/CustomInput/CustomOutlinedInput";
import CustomSelect from "components/CustomSelect/CustomSelect";
import Button from "components/CustomButtons/CustomButton";
import Avatar from "@material-ui/core/Avatar";
import { useTranslation } from "react-i18next";
import { useParams, useHistory } from "react-router-dom";
import CustomModal from "components/CustomModal/Modal";
import SweetAlert from "react-bootstrap-sweetalert";
import { RotatingLines } from "react-loader-spinner";
import Snackbar from "components/Snackbar/Snackbar";
import { useDispatch } from "react-redux";
import { getNew, saveNew } from "../Services/NewsService";
import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";
import { Textarea } from "@mui/joy";

const dashboardTypes = [
  { value: "Agent", label: "Agent" },
  { value: "Customer", label: "Customer" },
  { value: "Both", label: "Both" },
];

const newsTypes = [
  { value: "Article", label: "Article" },
  { value: "LinkVideo", label: "Link" },
  { value: "LinkVideo", label: "Video" },
  { value: "Photos", label: "Photos" },
  { value: "Document", label: "Document" },
];

const initialForm = {
  user_type: "",
  title: "",
  new: "",
  brief: "",
  complete_article: "",
  url: "",
  files_article: null,
  files_photos: [],
  files_document: null,
  filesNew: null,
};

const NewForm = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const { id, view } = useParams();

  const [form, setForm] = useState(initialForm);
  const [modalSuccess, setModalSuccess] = useState(false);
  const [alertLoading, setAlertLoading] = useState(null);
  const [messageToast, setMessageToast] = useState("");
  const [typeToast, setTypeToast] = useState("");
  const [toastMessage, setToastMessage] = useState(false);
  const [articlePreview, setArticlePreview] = useState("");
  const [photoPreviews, setPhotoPreviews] = useState(["", "", "", ""]);
  const [documentPreview, setDocumentPreview] = useState("");
  const [orderDataSuccess, setOrderDataSuccess] = useState({});
  const [isCompleted, setIsCompleted] = useState(false);

  useEffect(() => {
    if(localStorage.getItem("userType") !== "1") {
      window.location.href = "/admin/home";
    }
  }, []);

  useEffect(() => {
    if (id > 0) {
      fetchNews();
    }
  }, [id]);

  useEffect(() => {
    validateComplete(form);
  }, [form]);

  const fetchNews = async () => {
    const result = await dispatch(getNew({ id }));
    if (result.payload && result.payload.data) {
      const data = result.payload.data;
      setForm({
        user_type: data.new_data.user_type,
        title: data.new_data.title,
        new: data.new_data.type,
        brief: data.new_data.brief,
        complete_article: data.new_data.complete_new || "",
        url: data.new_resource_data[0].resource || "",
        files_article: null,
        files_photos: [],
        files_document: null,
        filesNew: null,
      });
      if (data.new_data.type === "Article" && data.new_resource_data) {
        setArticlePreview(
          `data:${data.new_resource_data[0].mimeType};base64,${data.new_resource_data[0].resourceBase64}`
        );
      }
      if (data.new_data.type === "Photos" && data.new_resource_data) {
        setPhotoPreviews(
          data.new_resource_data.map(
            (resource) =>
              `data:${resource.mimeType};base64,${resource.resourceBase64}`
          )
        );
      }
      if (data.new_data.type === "Document" && data.new_resource_data) {
        setDocumentPreview(
          `data:${data.new_resource_data[0].mimeType};base64,${data.new_resource_data[0].resourceBase64}`
        );
      }
    }
  };

  const validateComplete = (data) => {
    let required = ["user_type", "title", "new"];
    let valid = required.every((prop) => data[prop] && data[prop] !== "");
    if (data.new === "Article") {
      valid =
        valid &&
        data.complete_article &&
        data.complete_article !== "" &&
        (articlePreview !== "" || (data.filesNew && data.filesNew.length > 0));
    }
    if (data.new === "LinkVideo") {
      valid = valid && data.url && data.url !== "";
    }
    if (data.new === "Photos") {
      valid =
        valid &&
        data.files_photos.length > 0 &&
        data.files_photos.every(
          (file, idx) => file || photoPreviews[idx] !== ""
        );
    }
    setIsCompleted(valid);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSelectChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFileChange = (e, type, idx = null) => {
    const file = e.target.files[0];
    if (type === "article" || type === "document") {
      const reader = new FileReader();
      reader.onload = (ev) => {
        const fileInfo = ev.target.result;
        const base64String = fileInfo.split(",")[1];
        setForm((prev) => ({
          ...prev,
          filesNew: [
            {
              data: base64String,
              type: file.type.split("/")[1],
            },
          ],
        }));
        type === "article"
          ? setArticlePreview(fileInfo)
          : setDocumentPreview(fileInfo);
      };

      reader.readAsDataURL(file);
    }
    if (type === "photo") {
      const reader = new FileReader();
      reader.onload = (ev) => {
        let previews = [...photoPreviews];
        previews[idx] = ev.target.result;
        const fileInfo = ev.target.result;
        const base64String = fileInfo.split(",")[1];
        let files = [...form.files_photos];
        files[idx] = {
          data: base64String,
          type: file.type.split("/")[1],
        };
        setForm((prev) => ({
          ...prev,
          filesNew: files,
        }));
        setPhotoPreviews(previews);
      };
      reader.readAsDataURL(file);
    }
  };

  const loadingAlert = () => {
    setAlertLoading(
      <SweetAlert
        style={{ display: "block", marginTop: "-100px" }}
        title={<h5 style={{ color: "black" }}>{"Loading"}</h5>}
        allowEscape={false}
        closeOnClickOutside={false}
        showConfirm={false}
        showCancel={false}
      >
        <RotatingLines
          strokeColor="gray"
          strokeWidth="5"
          animationDuration="0.75"
          width="96"
          visible={true}
        />
      </SweetAlert>
    );
  };

  const saveNewsForm = async () => {
    if (isCompleted) {
      setToastMessage(false);
      loadingAlert();
      let dataSend = { ...form };
      if (id > 0) {
        dataSend.id = id;
      }
      const resultSubmit = await dispatch(saveNew(dataSend));
      setAlertLoading(null);
      if (resultSubmit.payload) {
        if (resultSubmit.payload.result) {
          setOrderDataSuccess(resultSubmit.payload);
          setModalSuccess(true);
        } else {
          if (resultSubmit.payload.message.errors) {
            let messageToast = "<ul>";
            resultSubmit.payload.message.errors.map(
              (error, index) =>
                (messageToast += `<li key=${index}>${error.Message}</li>`)
            );
            messageToast += `</ul>`;
            setMessageToast(messageToast);
            setToastMessage(true);
          }
        }
      }
    } else {
      setTypeToast("danger");
      let errorMessageIssue = "Please check the information in the form";
      setMessageToast(errorMessageIssue);
      setToastMessage(true);
    }
  };

  const handleCancel = () => {
    history.push("/admin/news");
  };

  return (
    <div>
      {alertLoading}
      <GridContainer
        justifyContent="center"
        alignItems="center"
        xs={12}
        sm={12}
        md={6}
        style={{ margin: "auto" }}
      >
        <Card>
          <CardBody>
            <GridItem xs={12} sm={12} md={12}>
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  saveNewsForm(form);
                }}
                encType="multipart/form-data"
              >
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <CustomSelect
                      labelText="Dashboard type"
                      menuItems={dashboardTypes}
                      inputProps={{
                        name: "user_type",
                        value: form.user_type,
                        onChange: handleSelectChange,
                        required: true,
                      }}
                      formControlProps={{ fullWidth: true }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={12}>
                    <CustomInput
                      labelText="Title"
                      inputProps={{
                        name: "title",
                        value: form.title,
                        onChange: handleInputChange,
                        minLength: 7,
                        maxLength: 50,
                        required: true,
                      }}
                      formControlProps={{ fullWidth: true }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={12}>
                    {id > 0 ? (
                      <CustomInput
                        labelText="Type"
                        inputProps={{
                          name: "new",
                          value: form.new,
                          readOnly: true,
                          required: true,
                        }}
                        formControlProps={{ fullWidth: true }}
                      />
                    ) : (
                      <CustomSelect
                        labelText="Type"
                        menuItems={newsTypes}
                        inputProps={{
                          name: "new",
                          value: form.new,
                          onChange: handleSelectChange,
                          required: true,
                        }}
                        formControlProps={{ fullWidth: true }}
                      />
                    )}
                  </GridItem>
                  {form.new === "Article" && (
                    <>
                      <GridItem xs={12} sm={12} md={12}>
                        <label>Image:</label>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 16,
                          }}
                        >
                          <Avatar
                            src={articlePreview}
                            alt="Article"
                            style={{ width: 150, height: 150 }}
                          />
                          <input
                            type="file"
                            name="files_article"
                            accept="image/*"
                            onChange={(e) => handleFileChange(e, "article")}
                            style={{ marginLeft: 16 }}
                          />
                        </div>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={12}>
                        <CustomInput
                          labelText="Complete Article"
                          inputProps={{
                            name: "complete_article",
                            value: form.complete_article,
                            onChange: handleInputChange,
                            multiline: true,
                            rows: 4,
                            required: true,
                          }}
                          formControlProps={{ fullWidth: true }}
                        />
                      </GridItem>
                    </>
                  )}
                  {form.new === "LinkVideo" && (
                    <GridItem xs={12} sm={12} md={12}>
                      <CustomInput
                        labelText="URL"
                        inputProps={{
                          name: "url",
                          value: form.url,
                          onChange: handleInputChange,
                          minLength: 7,
                          maxLength: 100,
                          required: true,
                        }}
                        formControlProps={{ fullWidth: true }}
                      />
                    </GridItem>
                  )}
                  {form.new === "Photos" && (
                    <>
                      {[0, 1, 2, 3].map((idx) => (
                        <GridItem xs={12} sm={6} md={6} key={idx}>
                          <label>Image {idx + 1}:</label>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 16,
                            }}
                          >
                            <Avatar
                              src={photoPreviews[idx]}
                              alt={`Photo ${idx + 1}`}
                              style={{ width: 80, height: 80 }}
                            />
                            <input
                              type="file"
                              name={`files_photos_${idx}`}
                              accept="image/*"
                              onChange={(e) =>
                                handleFileChange(e, "photo", idx)
                              }
                              style={{ marginLeft: 16 }}
                            />
                          </div>
                        </GridItem>
                      ))}
                    </>
                  )}
                  {form.new === "Document" && (
                    <>
                      <GridItem xs={12} sm={6} md={6}>
                        <label>Document:</label>
                        <input
                          type="file"
                          name="files_document"
                          accept=".pdf,.doc,.docx"
                          onChange={(e) => handleFileChange(e, "document")}
                        />
                      </GridItem>
                      {documentPreview && (
                        <GridItem xs={12} sm={6} md={6}>
                          <label>File Uploaded:</label>
                          <a
                            href={documentPreview}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Document
                          </a>
                        </GridItem>
                      )}
                    </>
                  )}
                  <GridItem xs={12} sm={12} md={12}>
                    <CustomInput
                      labelText="Brief"
                      inputProps={{
                        multiline: true,
                        rows: 4,
                        name: "brief",
                        value: form.brief,
                        onChange: handleInputChange,
                        maxLength: 200,
                        required: true,
                      }}
                      style={{ padding: "0px !important" }}
                      formControlProps={{ fullWidth: true }}
                    />
                  </GridItem>
                </GridContainer>
                <GridContainer
                  container
                  justifyContent="space-between"
                  alignItems="center"
                  style={{ minHeight: "100px", marginTop: "20px" }}
                >
                  <GridItem xs={4}>
                    <Button
                      type="button"
                      variant="outlined"
                      onClick={handleCancel}
                      style={{ width: "100%" }}
                    >
                      Cancel
                    </Button>
                  </GridItem>
                  <GridItem xs={4} />
                  <GridItem xs={4}>
                    <Button
                      type="submit"
                      variant="green"
                      disabled={!isCompleted}
                      style={{ width: "100%" }}
                    >
                      Save
                    </Button>
                  </GridItem>
                </GridContainer>
              </form>
              <CustomModal
                title=""
                isOpen={modalSuccess}
                onClose={() => history.push("/admin/news")}
                privacy={false}
                id={"successModal"}
              >
                <GridContainer>
                  <GridItem xs={12}>
                    <div className="sa">
                      <div className="sa-success">
                        <div className="sa-success-tip"></div>
                        <div className="sa-success-long"></div>
                        <div className="sa-success-placeholder"></div>
                        <div className="sa-success-fix"></div>
                      </div>
                    </div>
                  </GridItem>
                  <GridItem xs={12}>
                    <p style={{ fontSize: "20px" }}>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: orderDataSuccess.message,
                        }}
                      ></div>
                    </p>
                  </GridItem>
                  <GridItem xs={12}>
                    <Button
                      type="button"
                      variant="green"
                      onClick={() => history.push("/admin/news")}
                      block
                    >
                      Ok
                    </Button>
                  </GridItem>
                </GridContainer>
              </CustomModal>
              <Snackbar
                style={{ zIndex: "3000" }}
                place="br"
                color={typeToast}
                message={messageToast}
                open={toastMessage}
                closeNotification={() => setToastMessage(false)}
                close
              />
            </GridItem>
          </CardBody>
        </Card>
      </GridContainer>
    </div>
  );
};

export default NewForm;
